import React from "react";
import { styled } from "@mui/system";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ToolbarBottomProps = {
  label?: string;
  addNew?: () => void;
  topPosition?: boolean;
};

const iconAdd = (
  <FontAwesomeIcon
    icon={faPlus}
    style={{ color: "primary.tertiaryTextDefault" }}
  />
);

export const ToolbarBottom = styled((props: ToolbarBottomProps) => {
  const { addNew, label } = props;
  return (
    <Box
      sx={{
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        columnGap: 1.5,
        justifyContent: "start",
        height: "60px !important",
        px: "16px",
        backgroundColor: "primary.background",
        position: "absolute",
        width: "-webkit-fill-available",
        bottom: "0px"
      }}
    >
      <Button
        onClick={addNew}
        startIcon={iconAdd}
        type="submit"
        // component="div"
        sx={{ width: "100%" }}
        variant="text"
      >
        Add New {label}
      </Button>
    </Box>
  );
})(({ theme }) => ({}));
